import { useMemo } from 'react';
import { useDispatch } from 'src/store';
import { actions } from 'src/store/navbar';

export const useInlineFilterButtonsActions = () => {
  const dispatch = useDispatch();

  return useMemo(
    () => ({
      show: () => {
        dispatch(actions.showInlineFilterButtons());
      },
      hide: () => {
        dispatch(actions.hideInlineFilterButtons());
      },
      dockOnDesktop: () => {
        dispatch(actions.dockInlineFilterButtonsDesktop());
      },
      dockOnTablet: () => {
        dispatch(actions.dockInlineFilterButtonsTablet());
      },
      dockOnMobile: () => {
        dispatch(actions.dockInlineFilterButtonsMobile());
      },
      undockOnDesktop: () => {
        dispatch(actions.undockInlineFilterButtonsDesktop());
      },
      undockOnTablet: () => {
        dispatch(actions.undockInlineFilterButtonsTablet());
      },
      undockOnMobile: () => {
        dispatch(actions.undockInlineFilterButtonsMobile());
      },
    }),
    [dispatch]
  );
};
